import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    code = '',
    budgetItem = '',
    depDuty = '',
    jobActivity = '',
    isMajor = false,
    nature = '',
    projType = '',
    mainstay = '',
    timeLimit = '',
    startDate = '',
    endDate = '',
    disburseType = '',
    destUnit = '',
    fund = '',
    detail = '',
    compTpl = '',
    total = '',
    investment = '',
    level = '',
    sysProjType = '',
    paymentType = '',
    distribution = '',
    fundMgr = '',
    isPending = false,
    hotClass = '',
    isNewly = false,
    isCapital = false,
    isResearch = false,
    isReview = false,
    isInform = false,
    is3PMode = false,
    isSpecial = false,
    isInterest = false,
    bondCode = '',
    contactPer = '',
    contactTel = '',
    mobile = '',
    desc = '',
    remark = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.project.save, {
        id,
        name,
        code,
        budgetItem,
        depDuty,
        jobActivity,
        isMajor,
        nature,
        projType,
        mainstay,
        timeLimit,
        startDate,
        endDate,
        disburseType,
        destUnit,
        fund,
        detail,
        compTpl,
        total,
        investment,
        level,
        sysProjType,
        paymentType,
        distribution,
        fundMgr,
        isPending,
        hotClass,
        isNewly,
        isCapital,
        isResearch,
        isReview,
        isInform,
        is3PMode,
        isSpecial,
        isInterest,
        bondCode,
        contactPer,
        contactTel,
        mobile,
        desc,
        remark,
    }, options);
    if (error) return { error, status };
    return content || { id };
};
